import { useEffect } from 'react';
import { useMutation } from 'react-query';

import { axios } from '@/library/axios';
import { displayError } from '@/utils/functions/displayError';

export type ConfirmPayloadType = {
  data: ConfirmDataType | ConfirmVpa;
  id: string;
};

export type ConfirmVpa = {
  sellLotId: string;
  vpa: string;
};

export type ConfirmDataType = {
  sellLotId: string;
  accountNumber: string;
  ifscCode: string;
  accountHolderName: string;
  customerId: string;
  phoneNum: string | undefined;
};

const confirmOrder = (data: ConfirmPayloadType): Promise<any> => {
  return axios.post(
    `dg/customers/${data.id}/sell-orders?action=confirmation`,
    data.data
  );
};

export const useConfirmOrder = () => {
  const mutation = useMutation({
    mutationFn: confirmOrder,
  });

  useEffect(() => {
    displayError(mutation.error);
  }, [mutation.error]);

  return mutation;
};
